import _ from 'lodash';
import attSlideshowView from './attSlideshowComponent.html';
import './attSlideshowStyles.css';
import { ensure } from 'components/sharpr/ensure/ensure';

export function attSlideshowComponent() {
	return {
		bindings: {
			post: '<',
			geometry: '<',
			isMinimal: '<?',
			iconType: '<',
			fileCount: '<',
		},
		controllerAs: 'vm',
		controller: attSlideshowComponentCtrl,
		template: attSlideshowView,
	};
}

class attSlideshowComponentCtrl {
	constructor($scope, $element, $timeout, ImageSizer, Att, Api) {
		'ngInject';
		// save injections
		this.$scope = $scope;
		this.$element = $element;
		this.$timeout = $timeout;
		this.ImageSizer = ImageSizer;
		this.Att = Att;
		this.Api = Api;
		// setup initial values
		this.currIdx = 0;
		this.nextApiPage = 1;
		// save references to container elements
		this.slideshowContainer = this.$element[0].querySelector('.slideshow-container');
		this.slideContainer = this.$element[0].querySelector('.slideshow-image-container-inner');
		// initialization order: constructor, $onChanges, $onInit
		this.setInitialDrawerStyle();
	}

	$onInit() {
		// watch for posts that were edited and an attachment was added
		this.$scope.$watchGroup(['vm.post.attachment_page_count', 'vm.post.image.url'], () => {
			this.setup();
		});
	}

	$onChanges() {
		if (this.geometry && this.post) {
			this.pngGeometry = this.geometry.replace('.jpg', '.png');
			this.setup();
		}
	}

	setup() {
		// setup
		this.spec = this.ImageSizer.parse(this.pngGeometry);
		this.slides = [];
		if (this.slideContainer) {
			this.slideContainer.innerHTML = '';
		}
		this.attachmentPageCount = this.post.attachment_page_count;
		this.setupPreviewImages();
	}

	setInitialDrawerStyle() {
		if (!this.geometry || !this.post) {
			return;
		}
		this.initialPngGeometry = this.geometry.replace('.jpg', '.png');
		this.initialSpec = this.ImageSizer.parse(this.initialPngGeometry);
		const maxThumbWidth = this.isMinimal ? 270 : 260;
		const sizeType = this.initialSpec.boundingWidth > maxThumbWidth ? 'attachment_previews' : 'attachment_thumbnails';
		let size;
		if (this.post.image) {
			size = this.ImageSizer.getSize(this.post.image, this.initialPngGeometry);
		} else if (this.post[sizeType] && this.post[sizeType][0]) {
			size = this.ImageSizer.getSize(this.post[sizeType][0], this.initialPngGeometry);
		} else {
			size = [0, 0];
		}
		this.drawerStyle = {
			width: '99999px',
			transition: 'all 1ms',
			transform: 'translateX(0px)',
			height: size[1] + 'px',
		};
	}

	setupPreviewImages() {
		const maxThumbWidth = this.isMinimal ? 270 : 260;
		const sizeType = this.spec.boundingWidth > maxThumbWidth ? 'attachment_previews' : 'attachment_thumbnails';
		if (this.post.image) {
			// if the post has an image, show it as the first "page"
			const size = this.ImageSizer.getSize(this.post.image, this.pngGeometry);
			const slide = {
				width: size[0],
				height: size[1],
				rawUrl: this.post.image.url,
				url: this.ImageSizer.url(this.post.image.url, this.pngGeometry),
			};
			this.slides.push(slide);
			this.renderSlide(slide);
			this.attachmentPageCount++;
		}
		if (this.post[sizeType]) {
			this.post[sizeType].forEach(image => {
				if (!image.url || !image.width || !image.height) {
					return;
				}
				const size = this.ImageSizer.getSize(image, this.pngGeometry);
				const slide = {
					width: size[0],
					height: size[1],
					rawUrl: image.url,
					url: this.ImageSizer.url(image.url, this.pngGeometry),
				};
				this.slides.push(slide);
				this.renderSlide(slide);
			});
		}
		// handle detail page media queries for mobile auto sizing
		if (window.isMobile || this.spec.boundingWidth > 320) {
			window.addEventListener(
				'resize',
				_.throttle(() => {
					this.$timeout(() => this.updateDrawerStyle());
				}, 50)
			);
		}
		const wait = window.isMobile && this.spec.boundingWidth > 320 ? 500 : 0;
		if (this.post[sizeType]) {
			this.$timeout(() => this.updateDrawerStyle(), wait);
		} else {
			this.$timeout(() => this.setIdx(1), wait);
		}
	}

	previewAttachments() {
		this.Att.popupPost(this.post);
	}

	updateDrawerStyle() {
		// assume all slides need to be the same width
		// this will position the slider and make it the right height
		let width, geometry;
		if (window.isMobile) {
			// width is variable based on screen width
			width = this.slideshowContainer.clientWidth;
			geometry = this.pngGeometry.replace(/\d+/, width);
		} else {
			// width is always the same as geometry
			if (this.isMinimal) {
				width = parseFloat(this.pngGeometry.match(/(\d+)x\d+$/)[1]); // NOTE: Match at index 1 is the width.
			} else {
				width = parseFloat(this.pngGeometry.trim().replace(/\D/g, '')); // NOTE: Eliminate all non-digits.
			}

			geometry = this.pngGeometry;
		}

		const currSlide = this.slides[this.currIdx] || this.slides[this.slides.length - 1];
		let size = currSlide ? this.ImageSizer.getSize(currSlide, geometry) : 0;
		let fullWidth = (this.isMinimal ? width : width * this.attachmentPageCount) + 'px';
		if (this.slideWidth != width) {
			this.updateSlideWidths(width);
		}
		this.slideWidth = width;
		const negativeX = this.currIdx * width * -1;
		this.drawerStyle = {
			width: fullWidth,
			transition: this.hasEverNavigated ? 'all 350ms' : 'all 1ms',
			transform: `translateX(${negativeX}px)`,
			height: size[1] + 'px',
		};
	}

	/**
	 * Set 0-based slide index
	 * @param {Number} newIndex  The index of the slide to show
	 */
	setIdx(newIndex) {
		if (this.isLoadingNextSlides) {
			return;
		}
		this.hasEverNavigated = true;
		this.currIdx = newIndex;
		if (!this.slides[newIndex] && !this.isLoadingNextSlides) {
			this.loadNextSlides();
		}
		this.updateDrawerStyle();
	}

	prev() {
		// go to prev
		if (this.currIdx === 0) {
			if (this.slides.length === this.attachmentPageCount && this.slides[this.slides.length - 1].elements) {
				// only wrap around to last slide if all slides are loaded
				this.setIdx(this.attachmentPageCount - 1);
			}
		} else {
			this.setIdx(this.currIdx - 1);
		}
	}

	next() {
		// go to next or wrap around to first slide
		if (this.currIdx === this.attachmentPageCount - 1) {
			this.setIdx(0);
		} else {
			this.setIdx(this.currIdx + 1);
		}
	}

	loadNextSlides() {
		const sizeType = this.spec.boundingWidth > 260 ? 'previews' : 'thumbnails';
		const params = {
			limit: 10,
			page: this.nextApiPage++,
		};
		this.isLoadingNextSlides = true;
		this.Api.get(`/v3/posts/${this.post.id}/attachments/${sizeType}`, params, {
			avoidLoadingBar: true,
		}).then(
			thumbnails => {
				this.isLoadingNextSlides = false;
				thumbnails = ensure.array(thumbnails);
				if (thumbnails.length === 0) {
					// error loading thumbnails
					return;
				}
				const existingUrls = _.pluck(this.slides, 'rawUrl');
				thumbnails.forEach(thumbnail => {
					if (!thumbnail.url || !thumbnail.width || !thumbnail.height) {
						// invalid thumbnail
						return;
					}
					if (existingUrls.includes(thumbnail.url)) {
						// already been rendered
						return;
					}
					const size = this.ImageSizer.getSize(thumbnail, this.pngGeometry);
					const slide = {
						width: size[0],
						height: size[1],
						rawUrl: thumbnail.url,
						url: this.ImageSizer.url(thumbnail.url, this.pngGeometry),
					};
					this.slides.push(slide);
					this.renderSlide(slide);
				});
				// update drawer to fit image properly
				this.updateDrawerStyle();
			},
			err => {
				// TODO: let user know of failure somehow?
				this.isLoadingNextSlides = false;
			}
		);
	}

	renderSlide(slide) {
		// create slide outer container
		const div = document.createElement('div');
		div.className = 'slideshow-image loader-bg';
		Object.assign(div.style, {
			height: slide.height + 'px',
			width: this.slideWidth + 'px',
		});
		// creat slide image
		const img = new Image();
		img.onload =
			img.onerror =
			img.onabort =
				() => {
					// remove spinner behind image after image is loaded
					// because the image might be a transparent png
					div.classList.remove('loader-bg');
				};
		Object.assign(img, {
			className: 'post-image att-slide-image',
			src: slide.url,
			width: this.slideWidth,
			height: slide.height,
			alt: '',
			draggable: 'false',
		});
		div.appendChild(img);
		// insert into dom
		this.slideContainer.appendChild(div);
		// save dom refs for when this.slideWidth changes
		slide.elements = { div, img };
	}

	updateSlideWidths(width) {
		this.slides.forEach(slide => {
			if (slide.elements) {
				slide.elements.div.style.width = width + 'px';
				slide.elements.img.width = width;
			}
		});
	}
}
